(() => {
  const dialog = document.getElementById("sc-swish-dialog");
  if (!dialog || dialog.dataset.scBound) return;
  dialog.dataset.scBound = "true";

  const loginReturnKey = "sc:wishlist:login-return:v1";
  const loginReturnTtl = 15 * 60 * 1000;
  function safeWishlistReturn(href, origin, previewTheme) {
    try {
      const url = new URL(href, origin);
      if (url.origin !== origin || url.username || url.password || /%2f|%5c|%00|%0a|%0d/i.test(url.pathname)) return null;
      const parts = decodeURIComponent(url.pathname).split("/").filter(Boolean);
      if (parts[0] && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(parts[0])) parts.shift();
      if (parts.some(part => !/^[\p{L}\p{N}._~-]+$/u.test(part))) return null;
      const publicPath = !parts.length || parts[0] === "products" && parts.length === 2 ||
        parts[0] === "collections" && (parts.length === 2 || parts.length === 4 && parts[2] === "products") ||
        parts[0] === "pages" && parts.length === 2 || parts[0] === "blogs" && [2, 3].includes(parts.length) ||
        parts[0] === "search" && parts.length === 1 || parts.join("/") === "apps/wishlist";
      if (!publicPath) return null;
      const target = new URL(url.pathname, origin);
      for (const [key, value] of url.searchParams) {
        const valid = key === "variant" && /^\d{1,20}$/.test(value) || key === "page" && /^\d{1,6}$/.test(value) ||
          key === "sort_by" && /^(manual|best-selling|title-ascending|title-descending|price-ascending|price-descending|created-ascending|created-descending|relevance)$/.test(value) ||
          key === "filter.v.availability" && /^[01]$/.test(value) || /^filter\.v\.price\.(gte|lte)$/.test(key) && /^\d{1,8}(?:\.\d{1,2})?$/.test(value) ||
          key === "locale" && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(value) || key === "currency" && /^[A-Z]{3}$/.test(value) ||
          key === "country" && /^[A-Z]{2}$/.test(value);
        if (valid) target.searchParams.append(key, value);
      }
      if (/^\d{1,20}$/.test(previewTheme || "")) target.searchParams.set("preview_theme_id", previewTheme);
      target.searchParams.sort();
      return target.pathname + target.search;
    } catch { return null; }
  }

  function buildWishlistLogin(href, origin, route, nonce, previewTheme) {
    const path = safeWishlistReturn(href, origin, previewTheme);
    if (!path || !/^[a-f0-9-]{32,36}$/i.test(nonce || "")) return null;
    try {
      const login = new URL(route, origin);
      if (login.origin !== origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?customer_authentication\/login$/i.test(login.pathname)) return null;
      const target = new URL(path, origin);
      target.searchParams.set("sc_wishlist_return", nonce);
      login.searchParams.set("return_to", target.pathname + target.search);
      return { path, login: login.pathname + login.search };
    } catch { return null; }
  }

  function consumeWishlistReturn(storage, href, origin, previewTheme, now) {
    const url = new URL(href, origin), marker = url.searchParams.get("sc_wishlist_return");
    let state;
    try {
      state = JSON.parse(storage.getItem(loginReturnKey) || "null");
      if (state && (!Number.isFinite(state.at) || now < state.at || now - state.at > loginReturnTtl)) {
        storage.removeItem(loginReturnKey); state = null;
      }
      if (!marker) return null;
      storage.removeItem(loginReturnKey);
    } catch { state = null; }
    url.searchParams.delete("sc_wishlist_return");
    const path = safeWishlistReturn(href, origin, previewTheme);
    const valid = !!state && state.nonce === marker && state.path === path && state.reopen === true;
    return { reopen: valid, clean: valid ? path : url.pathname + url.search + url.hash };
  }

  function bindWishlistLoginReturn(openWishlist) {
    if (dialog.dataset.scLoginReturn !== "true" || !dialog.dataset.scStorefrontLogin) return () => {};
    const origin = window.location.origin, previewTheme = dialog.dataset.scLoginPreviewTheme;
    let timer = null, attempts = 0;
    const onLogin = event => {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const path = event.composedPath?.() || [event.target];
      const anchor = path.find(node => node instanceof Element && node.matches("a[href]"));
      if (!anchor || !path.some(node => node instanceof Element && node.matches("wishlist-page, #sc-swish-dialog")) &&
        !anchor.closest("wishlist-page, #sc-swish-dialog")) return;
      try {
        const old = new URL(anchor.href, origin);
        const nativeLogin = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?account\/login\/?$/i.test(old.pathname);
        const preparedLogin = anchor.dataset.scWishlistLogin === "true" &&
          /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?customer_authentication\/login$/i.test(old.pathname);
        if (old.origin !== origin || !nativeLogin && !preparedLogin) return;
        const nonce = window.crypto.randomUUID();
        const next = buildWishlistLogin(window.location.href, origin, dialog.dataset.scStorefrontLogin, nonce, previewTheme);
        if (!next) return;
        try { window.sessionStorage.setItem(loginReturnKey, JSON.stringify({ nonce, path: next.path, at: Date.now(), reopen: true })); }
        catch { return; }
        anchor.href = next.login;
        anchor.dataset.scWishlistLogin = "true";
      } catch { /* Keep the existing sign-in link when browser storage or routing is unavailable. */ }
    };
    document.addEventListener("click", onLogin, true);
    let returned = null;
    try { returned = consumeWishlistReturn(window.sessionStorage, window.location.href, origin, previewTheme, Date.now()); } catch {}
    if (returned) {
      window.history.replaceState(window.history.state, "", returned.clean);
      if (returned.reopen) {
        const restore = () => {
          if (!dialog.isConnected) return;
          const signedIn = dialog.dataset.scCustomerSignedIn === "true" || window.WishlistKing?.isLoggedIn === true;
          if (signedIn && openWishlist({ type: "sc:login-return" })) {
            dialog.querySelector('[role="tab"][aria-controls^="sc-manual-panel-"]')?.click();
          } else if (attempts++ < 60) timer = window.setTimeout(restore, 250);
        };
        restore();
      }
    }
    return () => { document.removeEventListener("click", onLogin, true); window.clearTimeout(timer); };
  }

  const root = document.documentElement;
  const lockAttribute = "data-sc-wishlist-scroll-lock";
  const fixedAttribute = "data-sc-wishlist-fixed";
  const variables = ["--sc-wishlist-scroll-top", "--sc-wishlist-scroll-left", "--sc-wishlist-body-width"];
  let lock = null;
  let touch = null;
  let backdropPointer = false;
  let cleanupLoginReturn = () => {};

  const acquire = () => {
    if (lock || !dialog.isConnected) return;
    lock = {
      x: window.scrollX, y: window.scrollY,
      inlineStyle: root.getAttribute("style"),
      attributes: [lockAttribute, fixedAttribute].map((name) => [name, root.getAttribute(name)]),
      variables: variables.map((name) => [name, root.style.getPropertyValue(name), root.style.getPropertyPriority(name)]),
      fixed: getComputedStyle(document.body).position !== "fixed",
    };
    const width = document.body.getBoundingClientRect().width;
    root.style.setProperty(variables[0], `${-lock.y}px`);
    root.style.setProperty(variables[1], `${-lock.x}px`);
    root.style.setProperty(variables[2], `${width}px`);
    lock.appliedStyle = root.getAttribute("style");
    root.setAttribute(lockAttribute, "");
    if (lock.fixed) root.setAttribute(fixedAttribute, "");
  };

  const release = () => {
    if (!lock) return;
    const previous = lock;
    lock = null;
    touch = null;
    // Unfix first, but retain overflow/smooth-scroll protection while restoring position.
    const fixedValue = previous.attributes[1][1];
    if (fixedValue === null) root.removeAttribute(fixedAttribute);
    else root.setAttribute(fixedAttribute, fixedValue);
    if (previous.fixed && getComputedStyle(document.body).position !== "fixed") {
      window.scrollTo({ left: previous.x, top: previous.y, behavior: "instant" });
    }
    for (const [name, value] of previous.attributes) {
      if (value === null) root.removeAttribute(name);
      else root.setAttribute(name, value);
    }
    // Restore our own properties only if another component changed root styles meanwhile.
    if (root.getAttribute("style") === previous.appliedStyle) {
      if (previous.inlineStyle === null) root.removeAttribute("style");
      else root.setAttribute("style", previous.inlineStyle);
    } else {
      for (const [name, value, priority] of previous.variables) {
        if (value) root.style.setProperty(name, value, priority);
        else root.style.removeProperty(name);
      }
      if (previous.inlineStyle === null && !root.style.length) root.removeAttribute("style");
    }
  };

  const open = (event) => {
    if (!customElements.get("wishlist-page")) return false;
    acquire();
    try {
      if (!dialog.open) {
        dialog.showModal();
        document.dispatchEvent(new CustomEvent("sc:wishlist-action", { detail: {
          name: "wishlist_open", source: event?.type === "sc:swish-added" ? "save_success" : event?.type === "sc:login-return" ? "manual" : "header", surface: "popup"
        } }));
      }
    } catch {
      release();
      return false;
    }
    return true;
  };

  const onTrigger = (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest("[data-sc-wishlist-open]")
      : null;
    if (!trigger || event.defaultPrevented || event.button !== 0 ||
        event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (open()) event.preventDefault();
  };

  const outside = (x, y) => {
    const rect = dialog.getBoundingClientRect();
    return x < rect.left || x > rect.right || y < rect.top || y > rect.bottom;
  };
  const onPointerDown = (event) => {
    backdropPointer = event.target === dialog && outside(event.clientX, event.clientY);
  };
  const onBackdropClick = (event) => {
    if (backdropPointer && event.target === dialog && outside(event.clientX, event.clientY)) dialog.close();
    backdropPointer = false;
  };
  const onTouchStart = (event) => {
    touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  };
  const onTouchMove = (event) => {
    if (!lock || !dialog.open || !touch || event.touches.length !== 1) return;
    const point = event.touches[0];
    const dx = touch.x - point.clientX, dy = touch.y - point.clientY;
    touch = { x: point.clientX, y: point.clientY };
    const vertical = Math.abs(dy) >= Math.abs(dx);
    const delta = vertical ? dy : dx;
    // Legacy iOS needs a boundary guard as well as CSS overscroll containment.
    if (dialog.contains(event.target) && !outside(point.clientX, point.clientY)) {
      for (let node = event.target; node instanceof Element && dialog.contains(node); node = node.parentElement) {
        const style = getComputedStyle(node);
        const overflow = vertical ? style.overflowY : style.overflowX;
        const position = vertical ? node.scrollTop : node.scrollLeft;
        const max = vertical ? node.scrollHeight - node.clientHeight : node.scrollWidth - node.clientWidth;
        if (/(auto|scroll)/.test(overflow) && max > 0 &&
            ((delta > 0 && position < max - 1) || (delta < 0 && position > 0))) return;
      }
    }
    if (delta && event.cancelable) event.preventDefault();
  };
  const onBeforeToggle = (event) => { if (event.newState === "open") acquire(); };
  // Native close is queued: an older close must not unlock a newly reopened dialog.
  const onClose = () => { if (!dialog.open) release(); };
  const onPageHide = () => {
    if (dialog.open) dialog.close();
    release();
  };
  const onMutation = () => {
    if (!dialog.isConnected) {
      release();
      observer.disconnect();
      cleanupLoginReturn();
      document.removeEventListener("click", onTrigger);
      document.removeEventListener("sc:swish-added", open);
      document.removeEventListener("touchstart", onTouchStart);
      document.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("pagehide", onPageHide);
      dialog.removeEventListener("beforetoggle", onBeforeToggle);
      dialog.removeEventListener("close", onClose);
      dialog.removeEventListener("pointerdown", onPointerDown);
      dialog.removeEventListener("click", onBackdropClick);
      delete dialog.dataset.scBound;
    } else if (dialog.open) acquire();
    else release();
  };
  const observer = new MutationObserver(onMutation);
  observer.observe(document, { subtree: true, childList: true, attributes: true, attributeFilter: ["open"] });

  document.addEventListener("click", onTrigger);
  document.addEventListener("sc:swish-added", open);
  document.addEventListener("touchstart", onTouchStart, { passive: true });
  document.addEventListener("touchmove", onTouchMove, { passive: false });
  window.addEventListener("pagehide", onPageHide);
  dialog.addEventListener("beforetoggle", onBeforeToggle);
  dialog.addEventListener("close", onClose);
  dialog.addEventListener("pointerdown", onPointerDown);
  dialog.addEventListener("click", onBackdropClick);
  cleanupLoginReturn = bindWishlistLoginReturn(open);
  onMutation();
})();
